<div class="lineout row armory-item">
	<img data-ref="icon">
	<div class="list wide">
		<div class="armory-item-summary" data-ref="summary"></div>
		<div class="row-compact float-bottom">
			<button class="lineout float-end" data-ref="download"></button>
		</div>
		<progress max="100" value="0" data-ref="progress" hidden></progress>
		<div class="placeholder fit float-end" data-ref="status" hidden>scenario downloaded</div>
	</div>
</div>
